module.exports = __webpack_public_path__ + "img/HomePage-banks.3ebddd6.webp";